import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
import VueRouter from "vue-router";

import store from "@/store";
import config from '@/config';

import routes from "@/router/routes";

import NotFoundPage from "@/views/error/Page.vue";
import AuthLogin from "@/views/auth/login/Page.vue";

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueLocalStorage);
Vue.use(VueRouter);

// 首页
const indexRoute = {
  path: "/",
  redirect: config.homeUrl,
};

// 首页
const loginRoute = {
  path: config.loginUrl,
  meta: {title: '系统登录'},
  component: AuthLogin,
};

// 404
const errorRoute = {
  path: "*",
  component: NotFoundPage,
};

// 校验登录
const checkIsLogin = () => {
  const token = Vue.localStorage.get("token")
  return !!token;
}

// 路由实例
const router = new VueRouter({
  mode: "hash",
  routes: [
    indexRoute,
    loginRoute,
    routes,
    errorRoute,
  ]
});

// 路由钩子
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = config.systemName;

  // 页面路径
  const path = to.path;
  const pathInfo = path.split('/');
  const page = pathInfo.slice(0, 4).join('/');
  store.commit('updatePage', page);

  // 面包屑
  if (to.meta && to.meta.title) {
    store.commit('updatePageTitle', to.meta.title);
  } else {
    store.commit('updatePageTitle', '');
  }

  // 校验登录
  if (to.path === config.loginUrl) {
    next();
  } else {
    if (checkIsLogin()) {
      next();
    } else {
      next({path: config.loginUrl, replace: true})
    }
  }
});

export default router;
